var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoneIcon = function SvgDoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#55CCDE",
    cx: 12,
    cy: 12,
    r: 11.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 7)",
    fill: "#55CCDE"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.319,
    cy: 1.28,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.239,
    cy: 1.28,
    r: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.163 10.48a7.431 7.431 0 0 0 6.208-3.37l-1.075-.694a6.134 6.134 0 0 1-5.815 2.745 6.14 6.14 0 0 1-4.406-2.745L0 7.111a7.433 7.433 0 0 0 5.334 3.321c.277.032.553.048.829.048z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/done-icon.62d566ea.svg";
export { ForwardRef as ReactComponent };